var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container mb-5" },
    [
      _c("div", { staticClass: "k-tabs" }, [
        _c("ul", { staticClass: "k-tabs__list" }, [
          _c(
            "li",
            {
              staticClass: "k-tabs__item",
              class: [
                { "k-tabs__item--active": _vm.activeTab === "myDiscussions" }
              ],
              on: {
                click: function($event) {
                  return _vm.tabChanged("myDiscussions")
                }
              }
            },
            [
              _c(
                "a",
                {
                  staticClass: "k-tabs__link",
                  attrs: { href: "javascript:;" }
                },
                [
                  _vm._v(
                    "Moje příspěvky (" + _vm._s(_vm.myDiscussionsCount) + ")"
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "k-tabs__item",
              class: [
                {
                  "k-tabs__item--active":
                    _vm.activeTab === "watchingDiscussions"
                }
              ],
              on: {
                click: function($event) {
                  return _vm.tabChanged("watchingDiscussions")
                }
              }
            },
            [
              _c(
                "a",
                {
                  staticClass: "k-tabs__link ",
                  attrs: { href: "javascript:;" }
                },
                [
                  _vm._v(
                    "Sledované příspěvky (" +
                      _vm._s(_vm.watchingDiscussionsCount) +
                      ")"
                  )
                ]
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "k-tabs__actions" }, [
          _c(
            "a",
            {
              staticClass: "k-tabs__actions-link",
              attrs: { href: _vm.DiscussionListLink }
            },
            [
              _vm._v(
                "\n                    Diskusní fórum\n                    "
              ),
              _c(
                "svg",
                {
                  staticClass:
                    "k-tabs__actions-icon k-tabs__actions-icon--after",
                  attrs: { role: "img", width: "15", height: "15" }
                },
                [
                  _c("use", {
                    attrs: {
                      fill: "currentColor",
                      "xlink:href": "/images/spritesheet.svg#arrow-right"
                    }
                  })
                ]
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "transition-group",
        {
          staticClass: "k-table",
          attrs: { name: "list-complete", tag: "div" }
        },
        [
          _vm._l(_vm.discussions.data, function(discussion) {
            return _c(
              "div",
              { key: discussion.id, staticClass: "k-table__row" },
              [
                _c("div", { staticClass: "k-table__cell" }, [
                  _c("div", { staticClass: "k-table__cell-image" }, [
                    _c("img", {
                      attrs: {
                        src: discussion.user.prev_url,
                        alt: "",
                        height: "67px"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mr-auto" }, [
                    _c("a", { attrs: { href: discussion.url } }, [
                      _c("strong", { staticClass: "k-strong d-block mb-2" }, [
                        _vm._v(_vm._s(discussion.title))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "k-table__cell-meta ml-0" }, [
                      _vm._v("Vytvořený dne " + _vm._s(discussion.created_at))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "k-table__cell k-table__cell--info" },
                  [
                    _c("div", { staticClass: "k-table__cell-meta mx-0" }, [
                      _c("strong", { staticClass: "k-strong d-block mb-2" }, [
                        _vm._v(_vm._s(discussion.responses_count))
                      ]),
                      _vm._v(" "),
                      _c("div", {}, [_vm._v("odpovědí")])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "k-table__cell k-table__cell--info" },
                  [
                    _c("div", { staticClass: "k-table__cell-meta mx-0" }, [
                      _c("strong", { staticClass: "k-strong d-block mb-2" }, [
                        _vm._v(_vm._s(discussion.views_count))
                      ]),
                      _vm._v(" "),
                      _c("div", {}, [_vm._v("zobrazení")])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "k-table__cell k-table__cell--last-post text-left"
                  },
                  [
                    _c("div", { staticClass: "k-table__cell-meta mx-0" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(discussion.latest_response_date) +
                          " od "
                      ),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: discussion.latest_response_user.detail_url
                          }
                        },
                        [
                          _c("strong", { staticClass: "k-strong" }, [
                            _vm._v(_vm._s(discussion.latest_response_user.name))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-2" }, [
                        _vm._v("poslední příspěvek")
                      ])
                    ])
                  ]
                )
              ]
            )
          }),
          _vm._v(" "),
          _vm.discussions.data && _vm.discussions.data.length === 0
            ? _c("div", { key: "0", staticClass: "k-table__cell p-3" }, [
                _vm._v(
                  "\n                Nebyly nalezeny žádné příspěvky.\n            "
                )
              ])
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("pagination", {
        staticClass: "mt-5",
        attrs: { data: _vm.discussions, limit: 2 },
        on: { "pagination-change-page": _vm.getData }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }